import * as React from "react"


export default function numBrandsColumn() {
    return {
        name: 'numBrands',
        label: 'Nº Brands',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: value => value
        }
    }
}